export const en = {
  app: {
    title: "Factory Daily Report",
    subtitle: "Enter on the floor, manage automatically",
  },
  common: {
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    add: "Add",
    manage: "Manage",
    status: "Status",
    active: "Active",
    confirmDelete: "Are you sure you want to delete?",
    empty: "No data",
    comingSoon: "Coming soon",
    logout: "Log out",
  },
  login: {
    title: "Factory Daily Report",
    subtitle: "Log in to continue",
    username: "Username",
    password: "Password",
    submit: "Log in",
    submitting: "Signing in…",
    invalid: "Invalid username or password",
    errorGeneric: "Something went wrong while signing in",
    demoTitle: "Demo accounts",
    demoHint: "Tap to autofill",
    demoRoleAdmin: "Administrator",
    demoRoleOperator: "Shop-floor operator",
  },
  home: {
    greeting: "Hello, {{name}}",
    subtitle: "Start today's work",
    action: {
      newReport: "New report",
      list: "View reports",
      admin: "Admin",
    },
  },
  admin: {
    tab: {
      dashboard: "Dashboard",
      equipment: "Equipment",
      processes: "Processes",
      specs: "Specs",
      tools: "Tools",
      categories: "Categories",
      users: "Users",
    },
    equipment: {
      title: "Equipment",
      equipmentNo: "Equipment No",
      name: "Name",
      machineType: "Machine type",
      add: "Add equipment",
      edit: "Edit equipment",
      qr: "QR code",
      qrPrint: "Print",
      qrHint: "Scan to start a daily report",
    },
    process: {
      title: "Processes",
      allEquipment: "All equipment",
      equipment: "Equipment",
      processName: "Process",
      carModel: "Car model",
      partNo: "Part No.",
      partName: "Part name",
      add: "Add process",
      edit: "Edit process",
    },
    spec: {
      title: "Inspection specs",
      allProcess: "Select process",
      kind: "Kind",
      specText: "Spec",
      period: "Period",
      nominal: "Nominal",
      add: "Add spec",
      edit: "Edit spec",
    },
    tool: {
      title: "Tools",
      toolSpec: "Tool spec",
      lifetime: "Lifetime",
      add: "Add tool",
      edit: "Edit tool",
    },
    category: {
      title: "Categories",
      downtime: "Downtime",
      defect: "Defect",
      name: "Name",
      add: "Add category",
      edit: "Edit category",
    },
    user: {
      title: "Users",
      username: "Username",
      name: "Name",
      role: "Role",
      lang: "Language",
      password: "Password",
      passwordReset: "Reset password (optional)",
      usernameRule: "4–20 chars, lowercase letter first, then letters/digits",
      add: "Add user",
      edit: "Edit user",
      roleValue: {
        admin: "Admin",
        manager: "Manager",
        operator: "Operator",
      },
    },
  },
  reports: {
    save: "Save",
    saved: "Saved",
    saveError: "Failed to save",
    new: {
      title: "New report",
      equipment: "Equipment",
      equipmentPick: "Pick equipment",
      date: "Work date",
      start: "Start",
    },
    list: {
      title: "Reports",
      date: "Date",
      equipment: "Equipment",
      allEquipment: "All equipment",
      from: "From",
      to: "To",
      producedDay: "Day (made/target)",
      producedNight: "Night (made/target)",
      download: "Download Excel",
    },
    tab: {
      header: "Header",
      inspect: "Inspect",
      defect: "Defect",
      downtime: "Downtime",
      tools: "Tools",
      log: "Log",
      photos: "Photos",
    },
    photos: {
      add: "Add photo",
      caption: "Caption (optional)",
      saveFirst: "Save the report first to attach photos.",
    },
    field: {
      process: "Process",
      targetDay: "Target (day)",
      targetNight: "Target (night)",
      producedDay: "Made (day)",
      producedNight: "Made (night)",
      heatNo: "HEAT No.",
      defectKind: "Defect type",
      downtimeKind: "Downtime reason",
    },
    toolMark: {
      clear: "Clear",
    },
    log: {
      anomalies: "Anomalies",
      issues: "Issues / Actions",
      occurTime: "Occurred at",
      deviation: "Deviation",
      afterToolChange: "Action after tool change",
      note: "Note",
      occurrence: "Occurrence",
      action: "Action taken",
    },
    slot: {
      dayStart: "D-1",
      dayMid: "D-2",
      dayEnd: "D-3",
      nightStart: "N-1",
      nightMid: "N-2",
      nightEnd: "N-3",
    },
    kind: {
      appearance: "Appearance",
      dimension: "Dimension",
    },
    shift: {
      day: "Day",
      night: "Night",
    },
    note: {
      minutes: "Unit: minutes",
    },
  },
  dashboard: {
    range: {
      today: "Today",
      week: "Last 7 days",
      month: "Last 30 days",
    },
    stat: {
      reports: "Reports",
      achievement: "Achievement",
      defectRate: "Defect rate",
      downtime: "Downtime",
    },
    outOfSpec: {
      title: "{{count}} out-of-spec measurement(s)",
      spec: "Spec",
      slot: "Slot",
      value: "Value",
    },
    panel: {
      byDate: "Trend by date",
      byDowntime: "Downtime by reason (min)",
      byDefect: "Defects by reason (ea)",
    },
  },
  health: {
    status: "API status",
    checking: "checking…",
  },
} as const;
